/* eslint-disable react/prop-types */
import {
  CCol,
  CRow,
  CForm,
  CModal,
  CButton,
  CSpinner,
  CModalBody,
} from "@coreui/react-pro";
import {
  handleSetApproval,
  handleShowApproval,
} from "src/configs/redux/action/modalAction";
import React from "react";
import * as Yup from "yup";
import BtnClose from "./BtnClose";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "src/components/formFields/SelectField";
import PasswordField from "src/components/formFields/PasswordField";
import { useGetEmployeeByRole, useVerifyPin } from "src/hooks/useMaster";
import { encode } from "base-64";

const ModalApproval = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { token, outlet_id } = useSelector((state) => state.user.profile);
  const { showApproval, roleName, url } = useSelector((state) => state.modal);

  const formik = useFormik({
    initialValues: {
      pin: "",
      employee_id: "",
    },
    validationSchema: Yup.object({
      pin: Yup.string().required("Pin Wajib diisi!"),
      employee_id: Yup.string().required("Nama employee wajib di pilih!"),
    }),
    onSubmit: handleProcess,
  });

  const { data: employeeOptions, isLoading: isLoadingEmployee } =
    useGetEmployeeByRole({
      dispatch,
      history,
      outlet_id: outlet_id,
      role: roleName ?? "",
      enabled: showApproval,
      url,
    });

  const { mutateAsync: verifyPin, isLoading } = useVerifyPin(dispatch, history);

  async function handleProcess(values) {
    const payload = {
      pin: Number(values.pin),
      employee_id: values.employee_id,
      status_pin: "ON",
    };
    const res = await verifyPin({ token, payload });
    dispatch(handleSetApproval(res.status ? payload : null));
    closeModalApproval(payload);
  }

  const closeModalApproval = (payload) => {
    dispatch(handleShowApproval(false, null, payload));
    formik.resetForm();
  };

  return (
    <CModal
      size="md"
      alignment="center"
      visible={showApproval}
      onClose={closeModalApproval}
    >
      <div className="modal-header">
        <div className="modal-title">Approval</div>

        <div
          onClick={closeModalApproval}
          style={{ marginRight: "0px", cursor: "pointer" }}
        >
          <BtnClose />
        </div>
      </div>

      <CModalBody>
        <CForm onSubmit={formik.handleSubmit}>
          <CRow>
            <CCol className="mb-3">
              <SelectField
                formik={formik}
                name="employee_id"
                options={employeeOptions}
                label="Pilih Nama Karyawan"
                placeholder="Pilih karyawan"
                isLoading={isLoadingEmployee}
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol className="mb-3">
              <PasswordField name="pin" formik={formik} label="Masukkan Pin" />
            </CCol>
          </CRow>

          <CRow className="me-1 ms-1">
            <CButton color="info" className="w-100 text-white " type="submit">
              {isLoading ? <CSpinner /> : "KONFIRMASI"}
            </CButton>
          </CRow>
        </CForm>
      </CModalBody>
    </CModal>
  );
};

export default ModalApproval;
